import { Component, Prop, h, Host } from '@stencil/core'
import { Awards } from './types'

/**
 * The weinfreunde-specific awards component uses the wf-award component
 * and interacts as a container to display multiple stickers.
 *
 * @example
 * <wf-awards awards={awards}></wf-awards>
 */
@Component({
    tag: 'wf-awards',
    shadow: true,
    styleUrl: 'wf-awards.scss',
})
// eslint-disable-next-line require-jsdoc
export class WfAwards {
    /**
     * The award data.
     */
    @Prop() awards!: Awards

    /**
     * The icon size of the blister.
     */
    @Prop() sizing ? = 'l'

    /**
     * Renders the component.
     */
    render() {
        return (
            <Host>
                {this.awards?.map(award => <wf-award {...award} sizing={this.sizing}></wf-award>)}
            </Host>
        )
    }
}
